import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApirestService {
  //public apiUrl: string = 'http://agro-tareas.binlab.io:4501/';
  //public apiUrl: string = 'http://localhost:8085/';
  public apiUrl: string = "https://back.courierandbeyond.com/";
  //public apiUrl: string = "http://206.81.1.106:8085/";
  //public apiUrl: string = "http://174.138.66.162:8085/";

  //services!:

  constructor(
    //private http: Http
    private httpClient: HttpClient,
  ) {
    //this.http = http;
  }

  /**
   *
   **/
  queryPostRegular(route: string, body: any): Observable<any> {
    //let headers = new Headers({ "Content-Type": "application/json" });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //let options = new RequestOptions({ headers: headers });
    //let repos = this.http.post(this.apiUrl.concat(route), body, options);
    let repos = this.httpClient.post(this.apiUrl.concat(route), body, {
      headers,
    });
    return repos;
  }

  queryPutRegular(route: string, body: any): Observable<any> {
    /* let headers = new Headers({ "Content-Type": "application/json" });
    let options = new RequestOptions({ headers: headers });
    let repos = this.http.put(this.apiUrl.concat(route), body, options); */
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let repos = this.httpClient.put(this.apiUrl.concat(route), body, {
      headers,
    });
    return repos;
  }

  queryGet(route: string): Observable<any> {
    /* let token = "Bearer ";
    if (
      null != localStorage.getItem("token") &&
      undefined != localStorage.getItem("token") &&
      "null" != localStorage.getItem("token")
    ) {
      token += localStorage.getItem("token");
    } else {
      token = null;
    }

    let headers = new Headers({ Authorization: token });
    let options = new RequestOptions({ headers: headers });
    let repos = this.http.get(this.apiUrl.concat(route), options); 
    return repos;*/
    let token = null;
    if (
      null != localStorage.getItem('token') &&
      undefined != localStorage.getItem('token') &&
      'null' != localStorage.getItem('token')
    ) {
      token = localStorage.getItem('token');
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    return this.httpClient.get(this.apiUrl + route + '?token=' + token, {
      headers: headers,
    });
    //.toPromise();
  }

  queryPost(route: string, body: any, network = 1): Observable<any> {
    /* let token = "Bearer ";
    if (
      null != localStorage.getItem("token") &&
      undefined != localStorage.getItem("token") &&
      "null" != localStorage.getItem("token")
    ) {
      token += localStorage.getItem("token");
    } else {
      token = null;
    }
    let headers = new Headers({ Authorization: token });
    let options = new RequestOptions({ headers: headers });
    let repos = this.http.post(this.apiUrl.concat(route), body, options);
    return repos; */
    let token = null;
    if (
      null != localStorage.getItem('token') &&
      undefined != localStorage.getItem('token') &&
      'null' != localStorage.getItem('token')
    ) {
      token = localStorage.getItem('token');
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    return this.httpClient.post(this.apiUrl + route + '?token=' + token, body, {
      headers: headers,
    });
    //.toPromise();
  }

  queryPostImg(route: string, body:any, network = 1): Observable<any>  {
   
    let token = null;
    if (
      null != localStorage.getItem("token") &&
      undefined != localStorage.getItem("token") &&
      "null" != localStorage.getItem("token")
    ) {
      token = localStorage.getItem("token");
    }
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.httpClient.post(this.apiUrl + route + "?token=" + token, body, {
      headers: headers,
    });
    //.toPromise();
  }

  /* queryPostImgRegular(route: string, body: any): Observable<any> {
    //let headers = new Headers({ "Content-Type": "application/json" });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    //let options = new RequestOptions({ headers: headers });
    //let repos = this.http.post(this.apiUrl.concat(route), body, options);
    let repos = this.httpClient.post(this.apiUrl.concat(route), body, {
      headers,
    });
    return repos;
  } */

  queryDelete(route: string): Observable<any> {
    /* let token = "Bearer ";
    if (
      null != localStorage.getItem("token") &&
      undefined != localStorage.getItem("token") &&
      "null" != localStorage.getItem("token")
    ) {
      //token += localStorage.getItem('token').substring(6, localStorage.getItem('token').length);
      token += localStorage.getItem("token");
    } else {
      token = null;
    }
    let headers = new Headers({ Authorization: token });
    let options = new RequestOptions({ headers: headers });
    let repos = this.http.delete(this.apiUrl.concat(route), options);
    return repos; */
    let token = null;
    if (
      null != localStorage.getItem('token') &&
      undefined != localStorage.getItem('token') &&
      'null' != localStorage.getItem('token')
    ) {
      token = localStorage.getItem('token');
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.httpClient.delete(this.apiUrl + route, { headers: headers });
  }

  //queryDelete2(route: string, params: any): Observable<any>  {
  /* let token = "Bearer ";
    if (
      null != localStorage.getItem("token") &&
      undefined != localStorage.getItem("token") &&
      "null" != localStorage.getItem("token")
    ) {
      token += localStorage.getItem("token");
    } else {
      token = null;
    }
    let headers = new Headers({ Authorization: token });
    let options = new RequestOptions({ headers: headers, params: params });
    let repos = this.http.delete(this.apiUrl.concat(route), options);
    return repos; */

  /* let token = null;
    if (
      null != localStorage.getItem("token") &&
      undefined != localStorage.getItem("token") &&
      "null" != localStorage.getItem("token")
    ) {
      token = localStorage.getItem("token");
    }

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });

    // Crear los parámetros de la solicitud
    const httpParams = new HttpParams({ fromObject: params });

    // Realizar la solicitud DELETE con parámetros y encabezados
    return this.httpClient.delete(this.apiUrl.concat(route), {
      headers: headers,
      params: httpParams,
    });
  } */

  queryExternalApi(route: string): Observable<any> {
    /* let repos = this.http.get(route);
    return repos; */
    return this.httpClient.get(route);
  }
}
